import { FileBrowser, Logo } from '@convergence/components';
import {
  FileBrowserSelectionType,
  TinkerBoxFileOrDirectory
} from '@convergence/types';
import { observer } from 'mobx-react';
import { API_ENDPOINT } from '../lib/api';
import { TinkerBoxConnectionStore } from '../stores/TinkerBoxConnectionStore';
import { useState } from 'react';

export interface Props {
  store: TinkerBoxConnectionStore;
}

export const TinkerBoxFileBrowser = observer((props: Props) => {
  const { store } = props;

  const [selectedFiles, setSelectedFiles] = useState<
    (TinkerBoxFileOrDirectory & { path: string; isFolder: boolean })[]
  >([]);

  const [path, setPath] = useState(['/home', 'ubuntu']);

  const files = store.directoryContents.map((f) => ({
    ...f,
    path: f.fullPath,
    isFolder: isDirectory(f)
  }));

  return (
    <div className="w-full h-full flex flex-col relative overflow-hidden">
      <FileBrowser
        className="h-full overflow-auto"
        path={path}
        filePathHomeDirectory={<Logo className="inline w-3 h-3" />}
        onCreateFolder={async (folder) => {
          store.createFolder(folder);
        }}
        selectionMode={FileBrowserSelectionType.NONE}
        files={files}
        searchDisabled={store.connectionState !== 'connected'}
        onSearch={async (query) => {
          const results = await store.search(query);
          return (
            results?.map((f) => ({
              ...f,
              path: f.fullPath,
              isFolder: isDirectory(f)
            })) ?? []
          );
        }}
        onNavigate={(path) => {
          setPath(path);
          store.getDirectoryContents(path.join('/'));
          if (store.syncPwd) {
            store.changeRemoteDirectory(path.join('/'));
          }
        }}
        readOnly={true}
        selection={selectedFiles}
        onSelectionChange={(files) => {
          setSelectedFiles(files);
        }}
        onDelete={async (paths) => {
          const path = paths[0]?.path;
          if (path) {
            store.deleteFile(path);
          }
        }}
        onUpload={async (files) => {
          const subscribe = await store.upload(files);
          return subscribe;
        }}
        onDownload={async ({ fullPath }) => {
          const a = document.createElement('a');
          const href = `${API_ENDPOINT}/tinker-box-connect/${
            store.tinkerBox?.id
          }?filepath=${encodeURIComponent(fullPath)}`;
          console.log('href', href);
          a.href = href;
          a.download = fullPath.split('/').pop() || '';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }}
      />
    </div>
  );
});

export function isFile(fileOrDirectory: TinkerBoxFileOrDirectory): boolean {
  return fileOrDirectory.permissions[0] === '-';
}

export function isDirectory(
  fileOrDirectory: TinkerBoxFileOrDirectory
): boolean {
  return fileOrDirectory.permissions[0] === 'd';
}
